import { render, staticRenderFns } from "./FormPartBusinessRelation.vue?vue&type=template&id=0c42d88a&scoped=true"
import script from "./FormPartBusinessRelation.vue?vue&type=script&lang=js"
export * from "./FormPartBusinessRelation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42d88a",
  null
  
)

export default component.exports